import { ProductImage } from 'src/common/common.interface'

export const setTimeoutForSaga = (fn: Function, time: number) => {
  setTimeout(() => {
    fn()
  }, time)
}

export const sortProductImagesByEventId = (productImages: ProductImage[]) => {
  let eventIdTemp = -1
  return productImages
    ?.sort((pi1, pi2) => {
      if (pi1.eventId && pi2.eventId) {
        return pi1.eventId - pi2.eventId
      }
      if (pi1.eventId && !pi2.eventId) {
        return 1
      }
      return -1
    })
    ?.map((pi) => {
      if (eventIdTemp !== pi.eventId && pi.eventId) {
        eventIdTemp = pi.eventId
      } else {
        eventIdTemp = -1
      }
      return {
        ...pi,
        showEventSummary: eventIdTemp !== -1
      }
    })
}

/* eslint-disable no-bitwise */
export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
/* eslint-enable no-bitwise */
